import * as sicredi from './repasseSicrediParser';
import * as cielo from './repasseCieloParser';
import * as stone from './repasseStoneParser';
import * as sipag from './repasseSipagParser';
import * as unica from './repasseUnicaParser';
import * as ifood from './repasseIfoodParser';
import * as pagseguro from './repassePagSeguroParser';
import * as mercadoPago from './repasseMercadoPagoParser';
import * as cappta from './repasseCapptaParser';
import * as tuna from './repasseTunaParser';
import * as getnet from './repasseGetnetParser';

export const detectAndProcess = (dadosArray) => {
    // Tenta Getnet (Aba Resumo)
    if (getnet.detectar(dadosArray)) {
        return getnet.processar(dadosArray);
    }

    // Tenta Tuna Vendas (Simulação D+1)
    if (tuna.detectar(dadosArray)) {
        return tuna.processar(dadosArray);
    }

    // Tenta IFood (muito específico) - pode retornar { repasses, orphans } ou array simples
    if (ifood.detectar(dadosArray)) {
        return ifood.processar(dadosArray);
    }
    
    // Tenta PagSeguro
    if (pagseguro.detectar(dadosArray)) {
        return pagseguro.processar(dadosArray);
    }

    // Tenta Mercado Pago
    if (mercadoPago.detectar(dadosArray)) {
        return mercadoPago.processar(dadosArray);
    }

    // Tenta Cappta
    if (cappta.detectar(dadosArray)) {
        return cappta.processar(dadosArray);
    }

    // Tenta Unica primeiro devido à especificidade de suas colunas
    if (unica.detectar(dadosArray)) {
        return unica.processar(dadosArray);
    }

    // Tenta Sipag
    if (sipag.detectar(dadosArray)) {
        return sipag.processar(dadosArray);
    }

    // Tenta Stone (Mais específico primeiro)
    if (stone.detectar(dadosArray)) {
        return stone.processar(dadosArray);
    }

    // Tenta Cielo
    if (cielo.detectar(dadosArray)) {
        return cielo.processar(dadosArray);
    }
    
    // Fallback: Sicredi (ou outro que encaixe na estrutura clássica)
    if (sicredi.detectar(dadosArray)) {
        return sicredi.processar(dadosArray);
    }

    // Lança erro caso não consiga detectar
    throw new Error('Formato de arquivo de repasses não reconhecido. Certifique-se de que é um arquivo válido do Sicredi, Cielo, Stone, Sipag, Unica, iFood, PagSeguro, Mercado Pago, Cappta ou Tuna (Vendas).');
};
